export default {
  "account": {
    "curatedCollections": "Bilduma komisarioak",
    "curatedCollectionsInfo": "Bilatu komisariotzat dituzun bilduma guztiak",
    "editProfile": "Editatu profila",
    "likes": "Atsegin |",
    "linkAccount": "Nire kontua",
    "linkLogin": "Saioa hasi",
    "linkLoginJoin": "Saioa hasi/Sartu",
    "linkLogout": "Saioa amaitu",
    "myProfile": "Nire profila",
    "notifications": {
      "loggedIn": "Saioa hasi zara. Ongi etorri!",
      "loggedOut": "Saioa amaitu duzu.",
      "noCollections": {
        "curated": "Oraindik ez duzu bildumarik hautatu",
        "private": "Oraindik ez duzu bilduma pribaturik sortu",
        "public": "Oraindik ez duzu bilduma publikorik sortu"
      },
      "noLikedItems": "Oraindik ez duzu ezein elementu atsegin"
    },
    "privateCollections": "Bilduma pribatuak",
    "profile": "Nire gustukoak & Bildumak",
    "profileSettings": "Profilaren ezarpenak",
    "publicCollections": "Bilduma publikoak",
    "settings": "Ezarpenak",
    "title": "Nire kontua"
  },
  "actions": {
    "accept": "Onartu",
    "cancel": "Utzi",
    "close": "itxi",
    "continue": "jarraitu",
    "download": "Deskargatu",
    "edit": "Editatu",
    "feedback": "Iritzia",
    "goBack": "Atzera egin",
    "goHome": "Joan hasierako orrialdera",
    "learnMore": "Gehiago ikasi",
    "like": "Atsegin dut",
    "move": "Mugitu",
    "next": "Hurrengoa",
    "pin": "Pin",
    "preview": "Aurrebista",
    "previous": "Aurrekoa",
    "providedBy": "{provider} emanda",
    "reject": "Baztertu",
    "save": "Gorde",
    "send": "Bidali",
    "share": "Partekatu",
    "shareOn": "{social} partekatu",
    "skip": "Saltatu",
    "viewAt": "Ikusi hemen {link}",
    "viewDocument": "Dokumentua ikusi"
  },
  "attribution": {
    "country": "Herrialdea:",
    "creator": "Sortzailea:",
    "date": "Data:",
    "institution": "Erakundea:",
    "title": "Izenburua:"
  },
  "automatedCardGroup": {
    "item": "Azken elementuak",
    "organisation": "Erakundeak",
    "place": "Lekuak",
    "time": "Mende aipagarriak",
    "topic": "Nabarmendutako gaiak"
  },
  "blog": {
    "author": "Egilea",
    "authors": "Egileak",
    "blog": "Bloga",
    "by": "egilea",
    "categories": "Kategoriak",
    "category": "Kategoria",
    "posts": "Blogeko argitalpenak",
    "published": "Argitaratze data {date}",
    "relatedPosts": "Lotutako argitalpenak"
  },
  "cardLabels": {
    "organisation": "Antolaketa",
    "person": "Pertsona",
    "place": "Lekua",
    "theme": "Gaia",
    "time": "Mendea",
    "topic": "Gai"
  },
  "clearAllFilters": "Iragazki guztiak garbitu",
  "collections": {
    "actions": {
      "edit": "Editatu bilduma",
      "update": "Eguneratu Bilduma"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "diseinatzaileak",
          "name": "Diseinatzailea | Diseinatzaileak",
          "select": "Hautatu diseinatzaileak"
        },
        "proxy_dc_format": {
          "moreName": "teknikak",
          "name": "Teknika | Teknikak",
          "select": "Hautatu teknikak"
        },
        "proxy_dc_type": {
          "moreName": "elementu motak",
          "name": "Elementu mota | Elementu motak",
          "select": "Hautatu elementu motak"
        },
        "proxy_dcterms_medium": {
          "moreName": "materialak",
          "name": "Materiala | Materialak",
          "select": "Hautatu materialak"
        }
      }
    },
    "form": {
      "description": "Deskribapena"
    },
    "notifications": {
      "update": "Bilduma eguneratu egin da"
    }
  },
  "collectionsYouMightLike": "Gustatu ahal zaizkizun bildumak",
  "colourSwatch": "Kolore swatch",
  "contentYouMightLike": "Gustatu ahal zaizun edukia",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Informazio gehiago",
      "about": "Europeana bildumei buruz",
      "forDevelopers": "Garatzaileentzat",
      "help": "Laguntza",
      "meetUs": "Taldea ezagutu",
      "provide": "Datu hornitzaile bihurtu",
      "subscribe": "Harpidetu zaitez gure Buletinera",
      "terms": "Erabilera baldintzak eta pribatutasun politika"
    },
    "headerNavigation": {
      "Collections": "Bildumak",
      "explore": "Arakatu",
      "teachers": "Irakasleak"
    }
  },
  "curatedAutomatically": "Europeanak automatikoki komisario lanak egin ditu",
  "dateFilter": {
    "endDate": "Amaiera data",
    "specificDate": "Data zehatza",
    "startDate": "Hasiera data",
    "to": "-ra"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana API gakoa",
      "noRequests": "Orri honetan ez da Europeana APIetarako eskaerarik erabili.",
      "settingsPageLinkText": "ezarpenen orria",
      "tip": "Aholkua: dagoeneko {apiKeyLink} bat baduzu, {settingsPageLink} atalean sar dezakezu eta API eskaera-esteka hauetan sartuko da.",
      "title": "API eskaerak"
    },
    "debug": "Araztu",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Sartu zure Europeana API gakoa eta API-eskaeretarako esteketan erabiliko da.",
          "label": "API gakoa"
        },
        "boosting": {
          "description": "Gaituta bazaude, aktibatu bilaketa-emaitzen orrietan bultzada-eremua, hainbat bultzada-konfigurazio ebaluatzeko.",
          "label": "Gaitu eremua areagotzea"
        },
        "enabled": {
          "description": "Gaituta badago, arazketa menua orri-oinean agertuko da.",
          "label": "Gaitu arazketa-menua"
        }
      },
      "title": "Ezarpenak"
    }
  },
  "delete": "Ezabatu",
  "depiction": "{title}-ren irudikapena",
  "directions": {
    "left": "Ezkerra",
    "right": "Eskuma"
  },
  "edmIsShownAtLinkAlt": "Ikusi hornitzailearen webgunean",
  "entity": {
    "actions": {
      "cancel": "Utzi",
      "pin": "Ainguratu elementua",
      "unpin": "Ainguratu elementua",
      "viewPinned": "Ikusi ainguratutako elementuak"
    },
    "labels": {
      "entity": "Entitatea"
    },
    "notifications": {
      "deleted": "Zure galeria ezabatu egin da.",
      "error": {
        "unpin": "Errore bat gertatu da elementua kentzean. Mesedez, saiatu berriro edo jakinarazi arazoa."
      },
      "pin": "Elementu hau \" {entity} \" bildumaren goialdean agertuko da. Aldaketa hau bilduma-orrian ikusgai izango denean jakinaraziko dizugu.",
      "pinLimit": {
        "body": "Oraingoz 24 elementu soilik leheneratu ditzakezu lehen orrian. Elementu hau itsatsi nahi baduzu, ziurtatu beste bat ainguratzen duzula eta saiatu berriro ainguratzen.",
        "title": "Ainguratutako elementu gehiegi"
      },
      "pinned": "Elementua ainguratu da. Bilduma honen lehen orrialdearen goialdean dago orain. 24 ordu behar izan ditzake guztientzat agertzeko.",
      "select": "Hautatu erlazionatutako entitate bat elementua ainguratzeko/desainguratzeko.",
      "unpin": "Elementu hau \"{entity}\" bildumaren goialdean erakusteari utziko zaio. Aldaketa hau bildumaren orrian ikusgai dagoenean jakinaraziko dizugu.",
      "unpinned": "Elementua ainguratu egin da. Jada ez dago bilduma honetako lehen orrialdearen goialdean. 24 ordu behar izan ditzake guztientzat desagertzeko."
    }
  },
  "error": "Akatsa",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Hau ezinezkoa da galeria pribatuak bere sortzaileak soilik ikusten dituelako. Galeriaren sortzailea ezagutzen baduzu, eskatu galeria publiko egiteko. Bestela, jakinarazi arazo hau iritzia botoia erabiliz.",
      "metaTitle": "Baimenik gabeko galeria",
      "title": "Oops! {newline} Beste pertsona baten galeria pribatua ikusten saiatzen ari zara."
    },
    "itemNotFound": {
      "description": "Hau arrazoi hauengatik izan daiteke: elementu hau ez da existitzen, edo; gure kalitate irizpideekin bat ez zetorrelako kaleratu zen, edo; eguneratu eta berriro argitaratu zen identifikatzaile esklusibo berri batekin, eta kasu horretan, saiatu berriro elementua aurkitzen.",
      "metaTitle": "Ez da aurkitu elementua",
      "title": "Oh ez! {newline} Ezin izan dugu elementu hau aurkitu."
    }
  },
  "exhibitions": {
    "chapters": "Kapituluak",
    "credits": "Kredituak",
    "currentChapter": "Oraingo kapitulua",
    "description": "Erakusketak arakatu",
    "exhibitions": "Erakusketa | Erakusketak"
  },
  "explore": "Esploratu",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "koloreak",
      "name": "Kolorea | Koloreak",
      "options": {
        "#000000": "Beltza",
        "#000080": "Navy-urdina",
        "#00008B": "Urdin iluna",
        "#0000CD": "Urdin ertaina",
        "#0000FF": "Urdina",
        "#006400": "Berde iluna",
        "#008000": "Web-berdea",
        "#008080": "Berde urdinxka",
        "#008B8B": "Zian iluna",
        "#00BFFF": "Zeru-urdin bizia",
        "#00CED1": "Turkesa iluna",
        "#00FA9A": "Udaberri-berde ertaina",
        "#00FF00": "Berdea",
        "#00FF7F": "Udaberri-berdea",
        "#00FFFF": "Zian",
        "#191970": "Gauerdiko urdina",
        "#1E90FF": "Dodger-urdina",
        "#20B2AA": "Itsaso-berde argia",
        "#228B22": "Baso-berdea",
        "#2E8B57": "Itsaso-berdea",
        "#2F4F4F": "Arbel-gris iluna",
        "#32CD32": "Lima-berdea",
        "#3CB371": "Itsaso-berde ertaina",
        "#40E0D0": "Turkesa",
        "#4169E1": "Errege-urdina",
        "#4682B4": "Altzairu-urdina",
        "#483D8B": "Arbel-urdin iluna",
        "#48D1CC": "Turkesa ertaina",
        "#4B0082": "Indigo",
        "#556B2F": "Oliba-berde iluna",
        "#5F9EA0": "Kadete-urdina",
        "#6495ED": "Nabar-lorea",
        "#663399": "Rebecca morea",
        "#66CDAA": "Akuamarina ertaina",
        "#696969": "Gris iluna",
        "#6A5ACD": "Arbel-urdina",
        "#6B8E23": "Oliba-kolore marroixka",
        "#708090": "Arbel-grisa",
        "#778899": "Arbel-gris argia",
        "#7B68EE": "Arbel-urdin ertaina",
        "#7CFC00": "Belar-berdea",
        "#7F0000": "Web-granatea",
        "#7F007F": "Web-morea",
        "#7FFF00": "Berde horixka",
        "#7FFFD4": "Akuamarina",
        "#800000": "Granatea",
        "#800080": "Morea",
        "#808000": "Oliba-kolorea",
        "#808080": "Web-grisa",
        "#87CEEB": "Zeru-urdina",
        "#87CEFA": "Zeru-urdin argia",
        "#8A2BE2": "Bioleta-urdina",
        "#8B0000": "Gorri iluna",
        "#8B008B": "Magenta iluna",
        "#8B4513": "Saddle-marroia",
        "#8FBC8F": "Itsaso-berde iluna",
        "#90EE90": "Berde argia",
        "#9370DB": "More ertaina",
        "#9400D3": "Bioleta iluna",
        "#98FB98": "Berde zurbila",
        "#9932CC": "Orkidea-kolore iluna",
        "#9ACD32": "Hori-berdea",
        "#A020F0": "Morea",
        "#A0522D": "Sienna-marroia",
        "#A52A2A": "Marroia",
        "#A9A9A9": "Gris iluna",
        "#ADD8E6": "Urdin argia",
        "#ADFF2F": "Berde-horia",
        "#AFEEEE": "Turkesa zurbila",
        "#B03060": "Granatea",
        "#B0C4DE": "Altzairu-urdin argia",
        "#B0E0E6": "Hauts-urdina",
        "#B22222": "Adreilu erregogorra",
        "#B8860B": "Urre-kolore iluna",
        "#BA55D3": "Orkidea-kolore ertaina",
        "#BC8F8F": "Marroi-arrosa",
        "#BDB76B": "Kaki iluna",
        "#BEBEBE": "Grisa",
        "#C0C0C0": "Zilar-kolorea",
        "#C71585": "Gorri-bioleta ertaina",
        "#CD5C5C": "Indiako gorria",
        "#CD853F": "Peru",
        "#D2691E": "Txokolate-kolorea",
        "#D2B48C": "Marroi argia",
        "#D3D3D3": "Gris argia",
        "#D8BFD8": "Kardua",
        "#DA70D6": "Orkidea-kolorea",
        "#DAA520": "Urre-kolorea",
        "#DB7093": "Gorri-bioleta zurbila",
        "#DC143C": "Gorrimina",
        "#DCDCDC": "Gainsboro kolorea",
        "#DDA0DD": "Aran-kolorea",
        "#DEB887": "Egur-kolore bizia",
        "#E0FFFF": "Zian argia",
        "#E6E6FA": "Izpilikua",
        "#E9967A": "Izokin-kolore iluna",
        "#EE82EE": "Bioleta",
        "#EEE8AA": "Urre-kolore zurbila",
        "#F08080": "Koral-kolore argia",
        "#F0E68C": "Kaki-kolorea",
        "#F0F8FF": "Alice urdina",
        "#F0FFF0": "Ezti-ihintza",
        "#F0FFFF": "Urdina",
        "#F4A460": "Hondar-marroia",
        "#F5DEB3": "Garia",
        "#F5F5DC": "Beixa",
        "#F5F5F5": "Ke zuria",
        "#F5FFFA": "Menda krema",
        "#F8F8FF": "Mamu-zuria",
        "#FA8072": "Izokin-kolorea",
        "#FAEBD7": "Antzinako zuria",
        "#FAF0E6": "Oheko arropa kolorea",
        "#FAFAD2": "Urre-kolore argia",
        "#FDF5E6": "Parpaila zaharra",
        "#FF0000": "Gorria",
        "#FF00FF": "Fuksia",
        "#FF1493": "Arrosa iluna",
        "#FF4500": "Gorri-laranja",
        "#FF6347": "Tomatea",
        "#FF69B4": "Arrosa bizia",
        "#FF7F50": "Koral kolorea",
        "#FF8C00": "Laranja iluna",
        "#FFA07A": "Izokin-kolore argia",
        "#FFA500": "Laranja",
        "#FFB6C1": "Arrosa argia",
        "#FFC0CB": "Arrosa",
        "#FFD700": "Urre-kolorea",
        "#FFDAB9": "Mertxika",
        "#FFDEAD": "Navajo zuria",
        "#FFE4B5": "Mokasina",
        "#FFE4C4": "Bisque",
        "#FFE4E1": "Arrosa",
        "#FFEBCD": "Almendra zuritua",
        "#FFEFD5": "Papaia",
        "#FFF0F5": "Izpilikua",
        "#FFF5EE": "Oskola",
        "#FFF8DC": "Artoa",
        "#FFFACD": "Limoi satina",
        "#FFFAF0": "Lore-zuria",
        "#FFFAFA": "Elurra",
        "#FFFF00": "Horia",
        "#FFFFE0": "Hori argia",
        "#FFFFF0": "Boli",
        "#FFFFFF": "Zuria"
      },
      "select": "Hautatu koloreak"
    },
    "COUNTRY": {
      "name": "Herrialde hornitzailea",
      "options": {
        "Albania": "Albania",
        "Austria": "Austria",
        "Belarus": "Bielorrusia",
        "Belgium": "Belgika",
        "Bosnia and Herzegovina": "Bosnia eta Herzegovina",
        "Bulgaria": "Bulgaria",
        "Croatia": "Kroazia",
        "Cyprus": "Zipre",
        "Czech Republic": "Txekiar Errepublika",
        "Denmark": "Danimarka",
        "Estonia": "Estonia",
        "Europe": "Europa",
        "Finland": "Finlandia",
        "France": "Frantzia",
        "Georgia": "Georgia",
        "Germany": "Alemania",
        "Greece": "Grezia",
        "Holy See (Vatican City State)": "Egoitza Santua (Vatikano Hiria)",
        "Hungary": "Hungaria",
        "Iceland": "Islandia",
        "Ireland": "Irlanda",
        "Israel": "Israel",
        "Italy": "Italia",
        "Latvia": "Letonia",
        "Lithuania": "Lituania",
        "Luxembourg": "Luxenburgo",
        "Macedonia": "Mazedonia",
        "Malta": "Malta",
        "Moldova": "Moldavia",
        "Montenegro": "Montenegro",
        "Netherlands": "Herbehereak",
        "Norway": "Norvegia",
        "Poland": "Polonia",
        "Portugal": "Portugal",
        "Romania": "Errumania",
        "Russia": "Errusia",
        "Serbia": "Serbia",
        "Slovakia": "Eslovakia",
        "Slovenia": "Eslovenia",
        "Spain": "Espainia",
        "Sweden": "Suedia",
        "Switzerland": "Suitza",
        "Turkey": "Turkia",
        "Ukraine": "Ukraina",
        "United Kingdom": "Erresuma Batua",
        "United States of America": "Ameriketako Estatu Batuak"
      },
      "select": "Hautatu herrialde hornitzaileak"
    },
    "CREATOR": {
      "moreName": "sortzaileak",
      "name": "Sortzailea | Sortzaileak",
      "select": "Hautatu agregatzaileak"
    },
    "DATA_PROVIDER": {
      "moreName": "erakundeak",
      "name": "Erakundea | Erakundeak",
      "select": "Aukeratu erakundeak"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Irudiaren orientazioa | Irudiaren orientazioak",
      "options": {
        "landscape": "Paisaia",
        "portrait": "Erretratua"
      },
      "select": "Hautatu irudien orientazioak"
    },
    "IMAGE_SIZE": {
      "name": "Irudiaren tamaina | Irudiaren tamainak",
      "options": {
        "extra_large": "4MP + estra handia (adibidez 2688 x 1520px)",
        "large": "1-4MP handia (adibidez 1920x1080px)",
        "medium": "0,5-1MP ertaina (adibidez 850x850px)",
        "small": "< 0,5MP txikia (adibidez 650x600px)"
      },
      "select": "Hautatu irudien tamainak"
    },
    "LANGUAGE": {
      "name": "Hizkuntza | Hizkuntzak",
      "options": {
        "ar": "Arabiera",
        "bg": "Bulgariera",
        "bs": "Bosniarra",
        "ca": "Katalana",
        "cs": "Txekiar",
        "cy": "Galesera",
        "da": "Daniera",
        "de": "Alemana",
        "el": "Grekoa",
        "en": "Ingelesa",
        "es": "Gaztelania",
        "et": "Estoniarra",
        "fi": "Finlandiera",
        "fr": "Frantsesa",
        "ga": "Irlandarra",
        "gd": "Gaelikoa",
        "he": "Hebreera",
        "hr": "Kroaziera",
        "hu": "Hungariera",
        "is": "Islandiera",
        "it": "Italiera",
        "lt": "Lituaniera",
        "lv": "Letoniera",
        "mk": "Mazedoniera",
        "mt": "Maltera",
        "mul": "Hainbat hizkuntza",
        "nl": "Holandarra",
        "no": "Norvegiarra",
        "pl": "Poloniarra",
        "pt": "Portugesa",
        "ro": "Errumaniera",
        "ru": "Errusiera",
        "sk": "Eslovakiera",
        "sl": "Esloveniera",
        "sq": "Albaniarra",
        "sr": "Serbiarra",
        "sv": "Suediera",
        "tr": "Turkiera",
        "uk": "Ukrainara"
      },
      "select": "Hautatu hizkuntzak"
    },
    "MIME_TYPE": {
      "name": "Fitxategiaren formatua | Fitxategien formatuak",
      "options": {
        "text/plain": "Testu arrunta"
      },
      "select": "Hautatu fitxategi formatuak"
    },
    "PROVIDER": {
      "moreName": "agregatzaileak",
      "name": "Agregatzailea | Agregatzaileak",
      "select": "Hautatu agregatzaileak"
    },
    "REUSABILITY": {
      "name": "Hau erabili dezaket?",
      "options": {
        "open": "Bai",
        "permission": "Agian, baimena beharrezkoa",
        "restricted": "Bai, baldintzekin",
        "uncategorized": "Sailkatu gabe"
      },
      "select": "Hautatu hau erabil dezakezun ala ez"
    },
    "TYPE": {
      "name": "Euskarri mota",
      "options": {
        "3D": "3D",
        "IMAGE": "Irudia",
        "SOUND": "Soinua",
        "TEXT": "Testua",
        "VIDEO": "Bideoa"
      },
      "select": "Hautatu euskarri motak"
    },
    "api": {
      "name": "Bilatu",
      "options": {
        "fulltext": "Testu osoko elementuak",
        "metadata": "Metadatuak soilik diren elementuak"
      },
      "switch": "Bilatu testu osoa duten elementuen edukian soilik",
      "switchMoreInfo": "Bilduma honetan, zer bilatu nahi duzun aukeratu dezakezu: etengailu hau aktibatuta badago, egunkariaren eta dokumentuaren testuaren barruan bilatuko duzu; desaktibatuta badago, elementua deskribatzen duen informazioaren barruan bilatuko duzu, beste bilduma gehienetan beti egiten duzun bezala."
    },
    "button": {
      "apply": "Aplikatu",
      "cancel": "Bertan behera utzi",
      "morefilters": "Iragazki gehiago",
      "reset": "Berrezarri",
      "showAll": "Erakutsi guztiak {label}",
      "showLess": "Erakutsi gutxiago {label}"
    },
    "collection": {
      "name": "Gaia",
      "options": {
        "archaeology": "Arkeologia",
        "art": "Artea",
        "fashion": "Moda",
        "industrial": "Industria ondarea",
        "manuscript": "Eskuizkribuak",
        "map": "Mapak eta Geografia",
        "migration": "Migrazioa",
        "music": "Musika",
        "nature": "Historia Naturala",
        "newspaper": "Egunkariak",
        "photography": "Argazkilaritza",
        "sport": "Kirola",
        "ww1": "Lehen Mundu Gerra"
      },
      "select": "Hautatu gai bat"
    },
    "contentTier": {
      "name": "Elementuaren kalitatea",
      "options": {
        "*": "Gure argitalpen irizpideak betetzen ez dituzten elementuak barne hartzen ditu",
        "0": "Erakutsi soilik gure argitalpen irizpideak betetzen ez dituzten elementuak",
        "1": "Kalitate baxua",
        "2": "Kalitate ertaina",
        "3": "Kalitate handiko eta baldintzarekin berrerabilgarria",
        "4": "Kalitate handikoa eta libreki berrerabil daitekeena"
      },
      "select": "Hautatu elementuen kalitateak"
    },
    "moreOptions": "Bilatu {0} gehiago {1} aurkitzeko.",
    "proxy_dc_format": {
      "name": "Formatua | Formatuak",
      "select": "Hautatu  formatuak"
    },
    "proxy_dc_type": {
      "name": "Mota | Motak",
      "select": "Hautatu motak"
    },
    "proxy_dcterms_issued": {
      "name": "Igortze data"
    },
    "proxy_dcterms_medium": {
      "name": "Komunikabidea | Komunikabideak",
      "select": "Hautatu euskarria"
    }
  },
  "feedback": {
    "emailOptional": "Baliteke jarraipena egitea nahi izatea. Idatzi zure posta elektronikoa gu zurekin harremanetan jartzeko pozik bazaude.",
    "failed": "Eskaerak huts egin du. Saiatu berriro mesedez.",
    "form": {
      "placeholders": {
        "email": "Idatzi zure helbide elektronikoa",
        "feedback": "Idatzi zure iritzia hemen"
      }
    },
    "policies": "Jarraituz gero, gure {0} onartzen duzu eta gure {1} onartzen duzu.",
    "privacyPolicy": "Pribatutasun politika",
    "success": "Zure iritzia bidali da.",
    "termsOfService": "Zerbitzu-baldintzak",
    "thankYou": "Eskerrik asko!",
    "title": "Bidali iritzia",
    "validEmail": "Idatzi balio duen helbide elektronikoa",
    "validFeedback": "Zure iritziak gutxienez 5 hitz izan behar ditu"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Laguntzaileak",
      "dcCoverage": "Lekua-Unea",
      "dcCreator": "Sortzailea",
      "dcDate": "Data",
      "dcDescription": "Deskribapena",
      "dcDuration": "Iraupena",
      "dcFormat": "Formatua",
      "dcIdentifier": "Identifikatzailea",
      "dcLanguage": "Hizkuntza",
      "dcPublisher": "Argitaletxea",
      "dcRelation": "Loturak",
      "dcRights": "Baimenak",
      "dcSource": "Iturria",
      "dcSubject": "Gaia",
      "dcTitle": "Izenburua",
      "dcType": "Objektu mota",
      "dctermsCreated": "Sortze data",
      "dctermsExtent": "Hedadura",
      "dctermsHasPart": "honetan datza",
      "dctermsHasVersion": "honen bertsioa du",
      "dctermsIsFormatOf": "formatu bat da",
      "dctermsIsPartOf": "Honen parte da",
      "dctermsIsReferencedBy": "erreferentzia egin da",
      "dctermsIsReplacedBy": "ordezkatu da",
      "dctermsIsRequiredBy": "beharrezkoa da",
      "dctermsIssued": "Argitaratze data",
      "dctermsMedium": "Teknika",
      "dctermsProvenance": "Jatorria",
      "dctermsReferences": "erreferentzia egiten du",
      "dctermsSpatial": "Lekuak",
      "dctermsTOC": "Edukien taula",
      "dctermsTemporal": "Aldi baterako",
      "edmCountry": "Herrialde hornitzailea",
      "edmCurrentLocation": "Egungo kokapena",
      "edmDataProvider": "Erakunde hornitzailea",
      "edmHasMet": "ezagutu du",
      "edmIncorporates": "Barne hartzen ditu",
      "edmIntermediateProvider": "Bitarteko hornitzailea",
      "edmIsDerivativeOf": "eratorria da",
      "edmIsRelatedTo": "Lotuta dago",
      "edmIsRepresentationOf": "ordezkaria da",
      "edmIsSimilarTo": "-ren antzekoa da",
      "edmIsSuccessorOf": "ondorengoa da",
      "edmProvider": "Hornitzailea",
      "edmRealizes": "Konturatu da",
      "edmRights": "Elementu honen baimenen egoera (besterik adierazi ezean)",
      "edmUgc": "Erabiltzaileak sortutako edukia",
      "europeanaCollectionName": "Bildumaren izena",
      "keywords": "Gako-hitzak (komunitateak emandakoak)",
      "timestampCreated": "Dataren marka sortu da",
      "timestampUpdate": "Dataren marka eguneratu da",
      "wasPresentAt": "Bertan egon zen",
      "year": "Urtea"
    },
    "webResource": {
      "about": "RDF buruz",
      "dcDescription": "Deskribapena",
      "ebucoreHasMimeType": "Ebucore MIME mota",
      "edmRights": "Baliabide honetarako baimenen egoera",
      "rdfAbout": "RDF"
    }
  },
  "filter": "Iragazkia",
  "filterResults": "Iragazi emaitzak",
  "footer": {
    "customiseWebsiteLanguage": "Pertsonalizatu webgunearen hizkuntza",
    "disclaimerLine1": "Europeana Europar Batasunaren ekimena da, Europar Batasuneko Connecting Europe Facility eta Europar Batasuneko estatu kideek finantzatua. Europeana zerbitzuak, webgune hau barne, Europeana Fundazioak zuzentzen duen partzuergo batek kudeatzen ditu Europako Batzordearekiko zerbitzu kontratu baten pean.",
    "disclaimerLine2": "Europako Batzordeak ez du informazioaren zehaztasuna bermatzen eta ez du inolako erantzukizunik edo inolako erantzukizunik onartzen webgune honetako informazioari dagokionez. Ez Europako Batzordeak ez Europako Batzordearen izenean jarduten duen inor ez da erantzule edo erantzule egiten webgune honetako informazioaren zehaztasunaz edo erabileraz.",
    "findUsElsewhere": "Beste nonbait aurkitu gaitzazu",
    "imageDescription": "Europar Batasunak finantzatua",
    "navigation": {
      "MoreInfoLabel": "Informazio gehiago",
      "about": "Guri buruz",
      "accessibility": "Irisgarritasuna",
      "cookies": "Cookieak",
      "forDevelopers": "Garatzaileentzat",
      "help": "Laguntza",
      "privacy": "Pribatutasun politika",
      "provide": "Datu hornitzaile bihurtu",
      "subscribe": "Harpidetu zaitez gure Buletinera",
      "terms": "Zerbitzu-baldintzak"
    },
    "ourMission": "Gure eginkizuna",
    "ourMissionQuote": "Europeanak kultura ondarearen sektorea sendotzen du haren eraldaketa digitalean. Aldaketa digitalarekin bat egiteko esperientzia, tresnak eta politikak garatzen ditugu eta berrikuntza bultzatzen duten lankidetzak sustatzen ditugu."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Gure galeriak arakatu",
    "galleries": "Galeria | Galeriak"
  },
  "goToRecord": "Elementura joan",
  "header": {
    "backToMenu": "Menura itzuli",
    "clearQuery": "Garbitu bilaketa kontsulta",
    "closeSidebar": "Itxi Menua",
    "entireCollection": "Bilatu '{kontsulta}' gure bilduma osoan",
    "europeanaHome": "Europeanako hasiera orria",
    "inCollection": "Bilatu '{kontsulta}' bilduma honetan {collection}",
    "navigation": {
      "about": "Guri buruz",
      "collections": "Bildumak",
      "europeanaClassroom": "Irakasleentzat",
      "help": "Laguntza",
      "home": "Etxea",
      "pro": "Profesionalentzat",
      "stories": "Istorioak"
    },
    "quickSearch": "Bilaketa azkarra",
    "searchFor": "Bilatu",
    "searchForEverything": "Dena bilatu",
    "searchForEverythingInCollection": "Dena bilatu hemen {collection}",
    "searchForEverythingInEntireCollection": "Dena bilatu gure bilduma osoan",
    "searchForm": "Bilaketa formularioa",
    "showSidebar": "Erakutsi alboko barra",
    "sideNavigation": "Alboko nabigazioa"
  },
  "homeLinkAlt": "Europeana Hasiera orria",
  "homePage": {
    "discoverEditorial": "Azken istorioak",
    "storiesCTA": "Ikusi istorio guztiak",
    "subHeadline": "Milaka kultur erakundeetako artea, liburuak, filmak eta musika bilatu, gorde eta partekatu",
    "themesCTA": "Ikusi gai guztiak",
    "themesTitle": "Arakatu gaiaren arabera",
    "title": "Ezagutu Europako kultur ondare {digital}",
    "titleDigital": "digitala"
  },
  "imageSlider": {
    "handle": "Kontrola"
  },
  "items": {
    "itemCount": "Elementu 1 | {count} elementu",
    "itemOf": "{max}/{count} elementu",
    "recent": "Azken elementuak",
    "recommended": "Gomendatutako elementuak",
    "youMightLike": "Gustatu ahal zaizkizun elementuak"
  },
  "klaro": {
    "main": {
      "acceptAll": "Onartu guztiak",
      "acceptSelected": "Onartu hautatutakoa",
      "consentModal": {
        "description": "Zure datuen pribatutasuna serio hartzen dugu. Hemen webgune honetan erabili nahi genituzkeen zerbitzuak baloratu eta pertsonaliza ditzakezu. Arduraduna zara! Gaitu edo desgaitu zerbitzuak nahi duzun moduan.",
        "title": "Erabili nahiko genituzkeen zerbitzuak."
      },
      "consentNotice": {
        "description": "Zure pribatutasuna zaintzen dugu eta datuak soilik erabiltzen ditugu zure esperientzia hobetzeko. Ez dugu informazio pertsonalik erabiltzen publizitaterako. 15 egunez behin baimena alda dezakezu.",
        "learnMore": "Utzidazu aukeratzen"
      },
      "decline": "Gaitzetsi egiten dut",
      "ok": "ados",
      "purposes": {
        "essential": {
          "description": "Zerbitzu hauek funtsezkoak dira webgune honen funtzionamendu egokia izateko. Bilaketaren emaitzen ikuspegia eta hizkuntza hobespenak biltzen dituzte, saioa hasita gordetzen dute eta zure bisita seguru mantentzen dute. Ezin dituzu desgaitu, bestela webguneak ez lukeelako ondo funtzionatuko.",
          "title": "Segurtasunerako eta pertsonalizaziorako ezinbesteko zerbitzuak"
        },
        "usage": {
          "description": "Zerbitzu hauek informazioa biltzen dute webgunea nola erabiltzen den eta non dauden arazo puntuak hobeto ulertzen laguntzeko, zure esperientzia hobetzeko aukera informatuak egiteko aukera ematen digute.",
          "title": "Webgunearen erabilera eta iritziak jasotzeko zerbitzuak"
        }
      },
      "service": {
        "disableAll": {
          "description": "Erabili etengailu hau aukerako zerbitzu guztiak gaitzeko edo desgaitzeko.",
          "title": "Gaitu edo desgaitu zerbitzu guztiak"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Gure webgunea hobetzen laguntzen du noizean behin aldaketa esperimentalak aplikatuz.",
        "title": "A / B probak"
      },
      "auth-strategy": {
        "description": "Saioa hasteko erabili beharreko baimen estrategia gogoratzen du.",
        "title": "Auth Estrategia"
      },
      "debugSettings": {
        "description": "API eskaerak arazteko laguntzen du",
        "title": "Arazketa txandakatu"
      },
      "hotjar": {
        "description": "Inkesten widget bat aktibatzen du bisitarien gogobetetze inkestei erantzuteko aukera emanez.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Gogoratzen duzu etorkizunean sartzeko hobetsitako interfazearen hizkuntza.",
        "title": "Hizkuntza kodea"
      },
      "jira-servicedesk": {
        "description": "Iritzi trepeta aktibatzen du gurekin harremanetan jartzeko aukera emanez.",
        "title": "Jira zerbitzuko mahaia"
      },
      "matomo": {
        "description": "Bisitariek webgunearekin duten harremanari buruzko estatistika anonimoak biltzen ditu.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Jakinarazpen bat erakusten du funtzio berriak erabilgarri daudenean.",
        "title": "Ezaugarri berrien jakinarazpena"
      },
      "searchResultsView": {
        "description": "Gogoratzen duzu bilaketa-emaitzak zerrenda edo sareta ikuspegian ikustea nahiago baduzu.",
        "title": "Bilaketaren emaitzen ikuspegia (zerrenda / sareta)"
      }
    }
  },
  "layout": {
    "skipToMain": "Orrialdearen edukietara joan"
  },
  "learnMore": "Deskribapen honen iturria ezagutu",
  "loading": "Kargatzen",
  "loadingResults": "Emaitzak kargatzen",
  "messages": {
    "copyToClipboardSuccess": "Arbelera kopiatu da",
    "externalContentError": "Ezin izan da kanpoko edukia kargatu",
    "notFound": "Ez da aurkitu",
    "paginationLimitExceeded": "Bilaketaren lehen {limit} emaitzak besterik ezin dira ikusi."
  },
  "modal": {
    "download": {
      "clickToCopy": "Egin klik atribuzioan kopiatzeko",
      "modalIntro": "Elementu hau webean edo beste nonbait erabiltzen baduzu, ez ahaztu atribuzio hau bistaratzea ondoan:",
      "modalTitle": "Eskerrik asko"
    }
  },
  "multilingual": {
    "automated": "Itzulpen automatizatua",
    "enrichment": "Bazkide proiektuen aberastea",
    "other": "Beste hizkuntza batzuk",
    "stopTranslating": "Utzi elementu hau itzultzeari {0}.",
    "translateLanguage": "{0} -n ikusi nahi duzu?",
    "translateQuotaError": "Itzulpen zerbitzua ez dago aldi baterako erabilgarri. Saiatu berriro geroago."
  },
  "newFeatureNotification": {
    "dismiss": "Itxi",
    "readMore": "Gehiago irakurri",
    "text": {
      "searchFilters": "Orain balioak bila ditzakezu iragazki indibidualetan; begiratu ezazu!"
    }
  },
  "newWindow": "leiho berrian irekiko da",
  "noMoreResults": "Ez dago emaitza gehiagorik zure bilaketarako.",
  "noResults": "Emaitzarik ez",
  "of": "De",
  "organisation": {
    "city": "Hiria",
    "country": "Herrialdea",
    "englishName": "Ingelesezko izena",
    "nameAcronym": "Izenaren akronimoa"
  },
  "pageHasLoaded": "kargatu du",
  "pageNumber": "Orrialde zenbakia",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Izena"
        },
        "title": "Erakundeak"
      },
      "persons": {
        "title": "Pertsonak"
      },
      "places": {
        "title": "Lekuak"
      },
      "table": {
        "items": "Elementuak",
        "name": "Izena"
      },
      "times": {
        "title": "Garaiak"
      },
      "topics": {
        "title": "Gaiak"
      }
    }
  },
  "pagination": {
    "label": "Paginazioa"
  },
  "readMore": "Gehiago irakurri",
  "recommendation": {
    "prompts": {
      "accept": "Erpurua gora galerian gehitzeko",
      "reject": "Erpurua behera gustatzen ez bazaizu"
    }
  },
  "record": {
    "IIIFViewer": "IIIF ikuslea",
    "actions": {
      "pin": "Ainguratu elementua eskuragarri dauden Entitateetan"
    },
    "allMetaData": "Metadatu guztiak",
    "copyEmbedLabel": "Embed kodea (Egin klik kopiatzeko)",
    "exploreMore": "Gehiago arakatu",
    "extendedInformation": "Informazio zabaldua",
    "goodToKnow": "Ondo dago jakitea",
    "hideAll": "Informazio guztia ezkutatu",
    "location": "Kokapena",
    "locationOnMap": "Kokapena mapan",
    "mediaPlayer": "Multimedia erreproduzitzailea",
    "record": "Elementua",
    "showAll": "Informazio guztia erakutsi",
    "similarItems": "Antzeko elementuak",
    "status": {
      "unpublished": "[Argitaratu gabeko elementua]"
    },
    "transcription": "Transkripzioa",
    "transcriptionDisclaimer": "Eduki hori jendeak egin du, eta ez elementu hau eman duen erakundeak"
  },
  "related": {
    "editorial": {
      "title": "Gustuko izan ditzakezun istorioak"
    }
  },
  "relatedCollections": "Lotutako bildumak",
  "removeFilter": "Kendu {filterLabel} iragazkia",
  "reset": "Berrezarri",
  "resourceWikimedia": "Wikimedia Commons-eko baliabidea",
  "results": "Emaitzak",
  "resultsFor": "{0} emaitzak",
  "resultsLimitWarning": "Emaitza osagarriak ez dira erakusten, izan ere, bakarrik erakusten dira lehenengo 1000 emaitza garrantzitsuenak. BIlatzen duzuna aurkitu ez baduzu, bilaketa zehatzagoa egin.",
  "resultsWithin": "{0} {1} barruko emaitzak {2}",
  "search": {
    "boost": {
      "placeholder": "Sartu eremua sustatzeko kontsulta"
    },
    "title": "Bilatu"
  },
  "searchHasLoaded": "{0} emaitza itzuli dira",
  "searchPlaceholder": "Bilatu 50 milioi elementu baino gehiago",
  "searchResults": "Bilatu",
  "searchResultsFor": "{0} - Bilatu",
  "searchSuggestions": "Iradokizunak bilatu",
  "searchTier": {
    "button": {
      "hide": "Elementu hauek ezkutatu",
      "show": "Elementu hauek erakutsi"
    },
    "text": {
      "hide": "Gure argitalpen irizpideak betetzen ez dituzten elementuak erakusten ari dira.",
      "show": "Elementu gehiagok bat egiten dute zure bilaketarekin, baina ez datoz bat gure argitalpen irizpideekin."
    }
  },
  "searchViews": {
    "grid": "Lauki-sare ikuspegia",
    "list": "Zerrenda ikuspegia",
    "mosaic": "Mosaiko ikuspegia"
  },
  "set": {
    "actions": {
      "addTo": "Bildumara gaineratu",
      "create": "Bilduma sortu",
      "createNew": "Bilduma berria sortu",
      "delete": "Bilduma ezabatu",
      "edit": "Bilduma editatu",
      "update": "Bilduma eguneratu"
    },
    "form": {
      "description": "Bildumaren deskribapena",
      "private": "Bilduma hau pribatu gisa mantendu",
      "required": "Beharrezko eremua",
      "title": "Bildumaren izena"
    },
    "labels": {
      "curatedBy": "Komisarioa",
      "private": "Bilduma pribatua"
    },
    "notifications": {
      "deleted": "Bilduma ezabatu egin da.",
      "likeLimit": {
        "body": "Sentitzen dugu, baina momentuz 100 elementu atsegin daitezke, gehienez. Laster kenduko dugu muga hori!",
        "title": "100 atsegite"
      },
      "updated": "Elementua galerian gehitu da."
    },
    "prompts": {
      "delete": "Ziur zaude bilduma hau ezabatu nahi duzula? Bilduma ezabatuz gero, gaineratu dituzun elementu guztiak galduko dituzu."
    }
  },
  "showLess": "Gutxiago erakutsi",
  "showMore": "Gehiago erakutsi",
  "sideFilters": {
    "noOptions": "Ez dago aukerarik aukeratzeko",
    "search": "Bilatu"
  },
  "statuses": {
    "liked": "Gustatu",
    "pinned": "Ainguratuta"
  },
  "storiesPage": {
    "title": "Istorioak"
  },
  "website": "Webgunea",
  "youMightAlsoLike": "Baliteke ere gustatzea"
};
